import { render } from "./WForm.vue?vue&type=template&id=e124272c"
import script from "./WForm.vue?vue&type=script&lang=js"
export * from "./WForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__